import EmailEditorInnerPage from './EmailEditorInnerPage';

export default EmailEditorInnerPage;
